import React, { useState } from 'react'
import { Switch } from '@headlessui/react'

export default function SetUpPrivacySetting({auctionData,setAuctionData, setEditedAuctionData}) {

    return (
        <div className="privacy-content">
            {/* <!-- make auction private --> */}
            <div className="flex items-center pt-4">
                <Switch
                    data-testid="private-auction"
                    checked={auctionData.make_your_auction_private}
                    onChange={(value)=>{
                        setAuctionData(prevData => ({
                            ...prevData,
                            make_your_auction_private: value,
                        })),
                        setEditedAuctionData(prevData => ({
                            ...prevData,
                            make_your_auction_private: value,
                        }))
                        if(value===false){
                            setAuctionData(prevData => ({
                                ...prevData,
                                passcode: '',
                            })),
                            setEditedAuctionData(prevData => ({
                                ...prevData,
                                passcode: '',
                            }))                    
                        }
                    }
                    }
                    className="border w-[90px] h-[26px] flex items-center 
                justify-between border-[#A1A1A9] rounded-[54px] relative text-[10px] 
                font-medium leading-normal px-2"
                >
                    Yes
                    <span
                        className={`${
                            auctionData.make_your_auction_private ? '-translate-x-6' : 'translate-x-5'
                        } text-[10px] font-medium leading-normal rounded-xl min-w-[36px] cursor-pointer h-5 flex justify-center 
                    items-center bg-[#343434] text-[#FFFFFF]
                    m-0.5 text-center`}
                    >{auctionData.make_your_auction_private?'Yes':'No'}</span>
                    No
                </Switch>
                <p className="font-medium ml-2.5 text-[#343434] text-[10px] leading-normal">Make your auction private</p>
            </div>
            {/* <!-- passcode --> */}
            {auctionData.make_your_auction_private &&<div className="pt-3">
                <p className="font-medium text-[#343434] text-[12px] leading-normal">Passcode</p>
                <input autoComplete='off' type="text" id='passcode' 
                    maxLength={16}
                    value={auctionData.passcode}
                    onChange={(e)=>{setAuctionData(prevData => ({
                        ...prevData,
                        passcode: e.target.value,
                    })),setEditedAuctionData(prevData => ({
                        ...prevData,
                        passcode: e.target.value,
                    }))}}
                    className="border mt-1 border-[#A1A1A9] w-full px-3 py-3 outline-none text-[14px] 
                leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]" placeholder="Enter code" />
            </div>}
        </div>  
    )
}
